import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCtNK3v84UT0zyhmVFE0eGmx2Ge7zkuaZI",
  authDomain: "iam-business-group.firebaseapp.com",
  projectId: "iam-business-group",
  storageBucket: "iam-business-group.firebasestorage.app",
  messagingSenderId: "480176407871",
  appId: "1:480176407871:web:c660c1417bdb87a2cb7f8a"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
